/**
 * Variant specs table — updates the single data row when the customer changes variant.
 */
if (!customElements.get('variant-specs-table')) {
  customElements.define(
    'variant-specs-table',
    class VariantSpecsTable extends HTMLElement {
      connectedCallback() {
        if (this.dataset.static === 'true') return;

        this.jsonEl = this.querySelector('[data-variant-specs-json]');
        this.row = this.querySelector('.variant-specs-table__row');
        if (!this.jsonEl || !this.row) return;

        try {
          this.variantsData = JSON.parse(this.jsonEl.textContent);
        } catch {
          this.variantsData = [];
        }

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );
      }

      disconnectedCallback() {
        if (this.onVariantChangeUnsubscriber) {
          this.onVariantChangeUnsubscriber();
        }
      }

      handleVariantChange(event) {
        const { variant } = event?.data || {};
        if (!variant?.id) return;

        const rowData = this.variantsData.find((entry) => entry.id === variant.id);
        if (!rowData) return;

        this.row.dataset.variantId = variant.id;

        this.row.querySelectorAll('[data-field]').forEach((cell) => {
          const field = cell.dataset.field;
          cell.textContent = rowData[field] || '';
        });
      }
    }
  );
}
